"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 8 14" id=icon-chevron-right-small><path d="M1.005 14a1 1 0 01-.71-1.71l5.296-5.288L.296 1.714A1.004 1.004 0 011.714.294L7.71 6.292a1 1 0 010 1.41L1.714 13.7a.999.999 0 01-.709.3z"></path></symbol>';
};